import { isAfter, isBefore } from "date-fns";

export const checkStationAvailability = (station) => {
  const time = new Date();
  time.setSeconds(0);
  time.setMilliseconds(0);

  const [hours, minutes] = station.slot_end.split(":");
  const time2 = new Date();
  time2.setHours(hours, minutes, 0, 0);

  if (isBefore(time, time2)) return true;
  else !isAfter(time, time2);
};
